let stripe;
let elements;

window.initializeStripe = function initializeStripe(clientSecret) {
  const paymentForm = document.querySelector('.payment-summary__form');
  if (paymentForm) {
    if (typeof localData === 'object') {
      stripe = Stripe(localData.stripePublicKey, {
        locale: 'sl',
      });
    }
  }

  if(stripe) {
    localData.clientSecret = clientSecret;

    elements = stripe.elements({clientSecret});

    const paymentElement = elements.create('payment');
    paymentElement.mount('#payment-element');
  }
}

window.handleSubmitStripe = async function handleSubmitStripe(e) {
  const parent = e.target.closest('[data-step-form-parent]');
  const paymentSection = parent.querySelector('.step-form__payment');
  const paymentError = paymentSection?.querySelector('.step-form__alert-error');

  const { error, ...stripeData } = await stripe.confirmPayment({
    elements,
    confirmParams: {
      return_url: '',
    },
    redirect: 'if_required'
  });

  if (error) return;

  const formData = new FormData();
  formData.append('action', 'updateOrderStatus');

  const stripeResponseData = {};
  Object.keys(stripeData?.paymentIntent).forEach((key) => {
    stripeResponseData[key] = stripeData?.paymentIntent[key];
  });

  formData.append('stripe_response', JSON.stringify(stripeResponseData));

  const response = await fetch(`${localData.siteURL}`, {
    method: 'POST',
    body: formData,
  });
  const data = await response?.json();

  if(!data.success) {
    paymentError.classList.remove('hide');
    const textContainer = paymentError.querySelector('p');
    textContainer.textContent = data?.data?.message ?? 'An unexpected error occurred.';

    return;
  };

  parent.classList.remove('show-payment-screen');
  parent.classList.add('show-payment-thankyou');
}
